import { ReactNode } from 'react';
import { Motif, MotifVariant } from './Motif';

/** Structured empty state — replaces bare `.empty` divs. `motif` is portal-only flavor. */
export function EmptyState({ title, hint, action, motif }: {
  title: ReactNode;
  hint?: ReactNode;
  action?: ReactNode;
  motif?: MotifVariant;
}) {
  return (
    <div className="empty-state">
      {motif && <Motif variant={motif} size={56} className="es-motif" />}
      <div className="es-title">{title}</div>
      {hint != null && <div className="es-hint muted">{hint}</div>}
      {action != null && <div style={{ marginTop: 10 }}>{action}</div>}
    </div>
  );
}
